import * as React from 'react'
import { ReactElement } from 'react'
import { Formik } from 'formik'
import FormContainer from './FormContainer'

export type InjuryDto = {}

export type InjuryProps = {}

export default function InjuryForm(props: InjuryProps): ReactElement {
    return (
        <Formik<InjuryDto> initialValues={{}} onSubmit={() => {}}>
            <FormContainer {...props} />
        </Formik>
    )
}
